import React, { useEffect } from 'react'
import styles from './style.module.scss'
import Navbar from '../../Components/Navbar'
import { Helmet } from 'react-helmet'
import { HeaderCarousel } from '../../Components/Header'
import headerImg1 from '../../Assets/headerImgs/1-1.jpg'
import headerImg2 from '../../Assets/headerImgs/2-1.jpg'
import headerImg3 from '../../Assets/headerImgs/3.jpg'
import captionImg from '../../Assets/headerImgs/4141.jpg'

import feature1 from '../../Assets/headerImgs/feature1.png'
import feature2 from '../../Assets/headerImgs/feature2.png'
import feature3 from '../../Assets/headerImgs/feature3.png'

import whyUsContImg from '../../Assets/headerImgs/paralax-1.jpg'
import isoImg from '../../Assets/headerImgs/isoLogo.jpg'
import logoImg from '../../Assets/Logo.jpg'
import Copyrights from '../../Components/Copyrights'
import { use } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css';

const HomePage = () => {

  useEffect(() => {
    Aos.init({
      duration: 1000
    });
  }, [])

  const headerImgs = [headerImg1, headerImg2, headerImg3]
  return (
    <div className={styles.container}>
      <Helmet>
        <title>Home | Wedage & Company</title>
      </Helmet>
      <Navbar active="home" />
      <HeaderCarousel images={headerImgs} />
      <div className={styles.captionCont}>
        <img src={captionImg} alt="headerImg" />
        <div className={styles.caption} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
          <h1>We are specialized in the art of refrigerated transport.</h1>
          <p>We utilize the latest technology with the combination of more than 20 years of experience to provide the best services uniquely addressing the needs of every customer.</p>
        </div>
      </div>
      <div className={styles.featuresCont}>
        <div className={styles.featureCard} data-aos="fade-up">
          <img src={feature1} alt="GPS Tracking by mobile phone" />
          <p>Transport Vehicle GPS tracking<br />by mobile phone</p>
        </div>
        <div className={styles.featureCard} data-aos="fade-up">
          <img src={feature2} alt="Monitor Temperature of your goods" />
          <p>Temperature monitoring of your goods<br />by mobile phone</p>
        </div>
        <div className={styles.featureCard} data-aos="fade-up">
          <img src={feature3} alt="Double compartment trucks with Deep Freezer and Chiller" />
          <p>Double compartment trucks with<br />Deep Freezer and Chiller</p>
        </div>
      </div>

      <div className={styles.whyUsCont}>
        <img src={whyUsContImg} alt="whyChooseUs background Img" />
        <div className={styles.whyUsTextCont}>
          <h3>Why choose us?</h3>
          <ul>
            <li data-aos="fade-up">Reputed brand in the industry and trusted by major companies in the country</li>
            <li data-aos="fade-up">Well trained staff and large fleet of vehicles</li>
            <li data-aos="fade-up">Medical assurance of employees by regular medical checkups recommended for the industy</li>
            <li data-aos="fade-up">Solutions for every gap, every requirement tailor made to suit the customer</li>
            <li data-aos="fade-up">Optimum cost & asset performance due to using of own fleet and own technical team</li>
            <li data-aos="fade-up">Upgrades continuously with latest technologies which are not offered by other competitors</li>
            <li data-aos="fade-up">Ability to meet the requirements of small, medium and large scale enterprises</li>
          </ul>
        </div>
      </div>

      <div className={styles.isoCont}>
        <img src={isoImg} alt="ISO Img" />
        <p>We are in the process of obtaining ISO 9001:2015 Quality Management System</p>
      </div>

      <div className={styles.contactUsCont}>
        <img src={logoImg} alt="logo" />
        <div className={styles.contactUsTextCont}>
          <h3>Contact Us</h3>
          <p>Hot Line : <a href='tel:0718622996'>0718622996</a> <a href='tel:0718622997'>0718622997</a> <a href='tel:0718479758'>0718479758</a></p>
        </div>
      </div>

      <Copyrights />
    </div>

  )
}

export default HomePage